export default "/images/Canine.svg?bc3fdbd44af02cc278a203d04181891e";